<template>
  <div>
    <v-toolbar>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    </v-toolbar>
    <v-navigation-drawer app temporary absolute v-model="drawer">
      <v-btn v-show="isLoggedIn()" @click="handleLogout()">Log out </v-btn>
      <v-btn v-show="!isLoggedIn()" @click="handleLogin()">Log in </v-btn>
    </v-navigation-drawer>
    <v-content>
      <div class="display-2 mt-5 mb-5">{{title}}</div>
      <slot name="page_body"></slot>
      <v-footer class="pa-3 mt-5">
        <div>&copy;2018 UXLabs Ltd</div>
        <v-spacer></v-spacer>
        <v-btn flat :to="{name: 'About'}">About</v-btn>
        <v-btn flat :to="{name: 'Legal'}">Terms & Conditions</v-btn>
      </v-footer>
    </v-content>
  </div>
</template>

<script>
import { isLoggedIn, login, logout } from '@/utils/auth'

export default {
  name: 'Plain',
  props: ['title'],
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    handleLogin () {
      login()
      this.drawer = false
    },
    handleLogout () {
      logout(() => this.$router.push({name: 'Home'}))
      this.drawer = false
    },
    isLoggedIn () {
      return isLoggedIn()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/plain.vue